export default "__VITE_ASSET__CBYYFuth__"